<template>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="shown"
      headerClasses="justify-content-center"
      class="modal-options"
      :showClose ="false"
      bodyClasses="center"
      v-if="ItemsNotAvailable.length || ItemsWithDiffPrice.length"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
        <h4 slot="header" class="title title-up">{{ $t("text.order_type") }}</h4>
        <template>
           <i class="icon-style icon-color k-icon-menu" 
            ></i>
          <p v-if="!ItemsNotAvailable.length && ItemsWithDiffPrice.length" class="confirmation-message"><span>{{getOrderTypeText(newOrderType)}}</span></p>
          <div v-if="ItemsNotAvailable.length">
            <p class="confirmation-message" >{{ $t("message.items_not_available_for") }} <span>{{getOrderTypeText(newOrderType)}}</span></p>
            <p class="item-name" v-for="(item, index) in ItemsNotAvailable" :key="index" >{{item.name}}</p>
          </div>
          <div v-if="ItemsWithDiffPrice.length">
            <p class="confirmation-message">{{ $t("message.items_in_cart_price_changed") }}</p>
            <div class="grid-items" v-for="(item, index) in ItemsWithDiffPrice" :key="index">
              <div class="grid-item-name"> <p class="item-name">{{item.name}}</p></div>
              <div class="grid-item-price-status"><i class="icon-color" :class="getPriceIcon(item)"></i></div>
              <div class="grid-item-price"><p class="item-name">{{getMenuItemPrice(item,newOrderType)}}</p></div>
            </div>
          </div>
          
          <div v-if="ItemsNotAvailable.length || ItemsWithDiffPrice.length">
            <p class="confirmation-message">{{ $t("message.change_order_type_and_remove_from_cart") }}</p>
          </div>
          <div v-else><p class="confirmation-message">{{ $t("message.change_order_type") }}</p></div>
        </template>
         <template slot="footer">
        <n-button type="success" @click.native="confirmChanges"  >
         {{ $t("button.ok") }}
        </n-button>
        <n-button
          type="default"
          @click.native="closeModal"
          >{{ $t("button.cancel") }}</n-button
        >
      </template>
    </modal>
  </template>
  <script>
  import {
    Button,
    Modal,
  } from "@/components";
  import { getMenuItemPrice , getOrderTypeText} from "@/utilities/helper"
  export default {
    components: {
      [Button.name]: Button,
      Modal,
    },
    data(){
      return {
        shown : false,
        ItemsNotAvailable : [],
        ItemsWithDiffPrice : [],
        newOrderType : 1,
        oldOrderType : 1,
        getMenuItemPrice,
        getOrderTypeText
      }
    },
    methods:{
      openModal() {
        this.shown = true;
      },
      closeModal() {
        this.shown = false;
      },
      confirmChanges(){
          this.$root.$emit("CONFIRM_CHANGES", this.newOrderType)
      },
      closeModalEventListner(){
        this.$root.$off("CLOSE_POPUP_CONFIRMATION");
        this.$root.$on("CLOSE_POPUP_CONFIRMATION",()=>{
            this.closeModal();
        })
      },
      getPriceIcon(item){
          let new_price = parseFloat(getMenuItemPrice(item,this.newOrderType));
          let old_price = parseFloat(getMenuItemPrice(item,this.oldOrderType));
          return new_price > old_price
                  ? 'k-icon-priceup' : 'k-icon-pricedown'
      }
    },
    created(){
        this.closeModalEventListner()
    }
  
  }
  </script>
  <style scoped>
  .icon-style{
    font-size: 5rem;
  }
  .text-style{
    font-size: 1.5rem;
    font-weight: 800;
  }
  p.confirmation-message, p.confirmation-message span{
    line-height: 1.6em;
    font-weight: bold;
    font-size: 1.1em;
  }
  p.confirmation-message span, .icon-color{
    color:#FF6600 ;
  }
  p.item-name{
      line-height: 1.1em;
      font-size: 1em; 
  }
  .grid-items{
    display: grid;
    grid-template-columns: 70% 10% 20%;
  }
  .grid-item-name {
    grid-column: 1;
    text-align: start;
  }
  .grid-item-price-status {
    grid-column: 2;
  }
  .grid-item-price{
    grid-column: 3;
    text-align: end;
  }
  
  </style>